export default __webpack_public_path__ + "static/iot_image-94fe38e8c275be6a2e47f923f2f8d688.png";